import * as React from 'react'
import * as classNames from 'classnames'
import { getBannerStyles } from '@sphinx/components-styles'
import GlossaryErrorImageSrc from '../../assets/GlossaryError.svg'

const GlossaryErrorBanner = getBannerStyles({
  width: 180,
  height: 150,
  bannerImgSrc: GlossaryErrorImageSrc,
})

interface NoResultsBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  message: string
}

export const GlossaryErrorBannerComponent: React.FC<NoResultsBannerProps> = ({
  children,
  className,
  message,
  ...props
}) => (
  <div className={classNames(GlossaryErrorBanner, className)} {...props}>
    <p>{message}</p>
    {React.Children.toArray(children)}
  </div>
)
